<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';

const props = defineProps({
    viewId: String
});

// Store Access via Instance Proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// State
const options = ref(undefined);

// Computed Properties
const filters = computed(() => {
    return store.state[props.viewId].filters;
});

const filter = computed(() => {
    return filters.value.find(o => o.columnName === 'schoolId');
});

const filterKey = computed(() => {
    return filters.value.map(o => o.columnName).indexOf('schoolId');
});

const showArchive = computed(() => {
    return store.state[props.viewId].showArchive;
});

// Writable Computed for v-model
const schoolId = computed({
    get() {
        return parseInt(filter.value?.value) || '';
    },
    set(newSchoolId) {
        // If there is no active filter which filters by schoolId, then add it.
        if (filterKey.value === -1) {
            const type = 'relationshipOneToMany';
            const option = store.getters['advancedFilters/typesOptions'](type)[0];

            store.dispatch(props.viewId + '/addFilter', {
                columnName: 'schoolId',
                type: type,
                condition: option.condition,
                predicate: option.predicate,
                conditionText: option.text
            });
        }

        store.dispatch(props.viewId + '/setFilterProp', {
            key: filterKey.value,
            name: 'value',
            value: newSchoolId
        });
    }
});

// Watchers
watch(showArchive, async () => {
    await store.dispatch('odpCourseDatesMenus/schools');
    options.value = store.getters['odpCourseDatesMenus/schools'](showArchive.value);
}, { immediate: true });
</script>

<template>
    <select v-if="options" v-model="schoolId" class="form-select form-select-sm w-auto">
        <option v-for="option in options" :key="option.value" :value="option.value">
            {{ option.text }}
        </option>
    </select>
</template>